var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": _vm.layoutConfig,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 10, 15, 30, 50, 100, 300, 1000, 3000],
      "total": _vm.total,
      "current-page": _vm.firstPage
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };